import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/cloud-rain-wind.vue
var o = {
	name: "DtIconCloudRainWind",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--cloud-rain-wind"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Cloud Rain Wind",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M5.598 2.209a3 3 0 0 0-3.24 4.89.5.5 0 0 1-.715.7A4 4 0 1 1 8.209 3.5h.54c.001 0 0 0 0 0a2.75 2.75 0 0 1 1.529 5.037.5.5 0 1 1-.556-.832A1.75 1.75 0 0 0 8.75 4.5h-.895a.5.5 0 0 1-.48-.357A3 3 0 0 0 5.599 2.21Z",
		"clip-rule": "evenodd"
	}, null, -1), r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6.297 7.04a.5.5 0 0 1 .263.657l-1.5 3.5a.5.5 0 1 1-.92-.394l1.5-3.5a.5.5 0 0 1 .657-.263Zm-1.6-1a.5.5 0 0 1 .263.657l-1.5 3.5a.5.5 0 1 1-.92-.394l1.5-3.5a.5.5 0 0 1 .657-.263Zm4 0a.5.5 0 0 1 .263.657l-1.5 3.5a.5.5 0 1 1-.92-.394l1.5-3.5a.5.5 0 0 1 .657-.263Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=cloud-rain-wind.js.map